<a
	*ngIf="showDownloadIcon && currentPath === key"
	href="javascript:void(0)"
	(click)="downloadDataInCSV($event)"
	target="_blank"
>
	<i class="fa fa-download" aria-hidden="true"></i
></a>

<a
	*ngIf="showProductDownloadIcon"
	href="javascript:void(0)"
	class="product_csv_download_icon"
	(click)="downloadProductDataXLSX($event)"
>
	<span *ngIf="!disabledDownloadButton">
		<svg xmlns="http://www.w3.org/2000/svg" width="56" height="20" viewBox="0 0 56 20" class="enabled-download-icon">
			<g fill="none" fill-rule="evenodd">
				<rect class="download-button" width="55" height="19" x=".5" y=".5" rx="9.5" />
				<path
					class="arrow-icon-2"
					d="M11.5 4v9.949l3.743-3.742.707.707-4.95 4.95-4.95-4.95.707-.707L10.5 13.95 10.5 4h1z"
				/>
				<text class="arrow-icon" font-family="Assistant-Regular, Assistant" font-size="14">
					<tspan class="with-data" x="22" y="15">CSV</tspan>
				</text>
			</g>
		</svg>
	</span>

	<span *ngIf="disabledDownloadButton" aria-hidden="true">
		<svg xmlns="http://www.w3.org/2000/svg" width="56" height="20" viewBox="0 0 56 20" class="disabled-download-icon">
			<g fill="none" fill-rule="evenodd">
				<rect class="download-button" stroke="#d8d8d8" width="55" height="19" x=".5" y=".5" rx="9.5" />
				<path
					fill="#d8d8d8"
					class="arrow-icon-2"
					d="M11.5 4v9.949l3.743-3.742.707.707-4.95 4.95-4.95-4.95.707-.707L10.5 13.95 10.5 4h1z"
				/>
				<text fill="#d8d8d8" class="arrow-icon" font-family="Assistant-Regular, Assistant" font-size="14">
					<tspan x="22" y="15">CSV</tspan>
				</text>
			</g>
		</svg>
	</span>
</a>
